import React, {useEffect, useState} from 'react';
import {DateTime, Duration} from "luxon";
import clsx from "clsx";

import {AppCodeProps} from './AppCodeProps'
import AppButton from "../../atoms/AppButton/AppButton";
import {UI_BUTTON_TYPE} from "../../atoms/AppButton/AppButtonProps";
import {AppFrame} from "../../atoms/AppFrame/AppFrame";
import Paragraph from "../../atoms/Paragraph/Paragraph";
import {sleep} from "../../../common/helpers/helpers";
import PageHeader from "../../atoms/PageHeader/PageHeader";
import {HEADER_LEVEL} from "../../atoms/PageHeader/PageHeaderProps";
import {APP_COLOR, APP_FONT_SIZE} from '../../atoms/AtomsGlobalProps'
import {ReactComponent as InfoIcon} from './../../../icons/svg/info.svg'

import './AppCodeStyles.scss'
import AppIcon from "../../atoms/AppIcon/AppIcon";


const AppCode = (props: AppCodeProps) => {

    const {
        code,
        className,
        disabled,
        validDate,
        onClick,
        style
    } = props

    const [isMobywatelCodeActive, setIsMobywatelCodeActive] = useState<boolean>(true);
    const [intervalId, setIntervalId] = useState<NodeJS.Timeout | null>(null)
    const [isCopying, setIsCopying] = useState(false)
    const [buttonText, setButtonText] = useState<string>(() => 'Skopiuj kod');


    useEffect(() => {
        if (!validDate) {
            setIsMobywatelCodeActive(false);
            return;
        }
        refresh(validDate);
    }, [validDate])


    // @ts-ignore
    const [timeToCodeExpiresInSeconds, setTimeToCodeExpiresInSeconds] =
        useState<number | null | undefined>()


    const refresh = (validDate: DateTime): void => {
        const now = DateTime.utc();
        if (!validDate) {
            setIsMobywatelCodeActive(false);
            setTimeToCodeExpiresInSeconds(null);
            return;
        }
        let diffInSeconds = validDate.diff(now, "seconds").seconds;
        if (diffInSeconds < 0) {
            setIsMobywatelCodeActive(false);
            setTimeToCodeExpiresInSeconds(null);
            return;
        } else {
            setIsMobywatelCodeActive(true);
            setTimeToCodeExpiresInSeconds(diffInSeconds)
        }

        const id = setInterval(() => {
            setTimeToCodeExpiresInSeconds((prevSeconds) => {
                if (!prevSeconds) {
                    return diffInSeconds
                } else if (prevSeconds >= 1) {
                    return prevSeconds - 1
                } else {
                    setIsMobywatelCodeActive(false);
                    clearInterval(id)
                    return;
                }
            })
        }, 1000)

        setIntervalId(id)
        return;
    }

    const handleOnClick = (e: React.MouseEvent<HTMLButtonElement>) => {
        if (disabled) {
            return
        } else {
            onClick(e)
        }
    }


    const handleOnCopyClick = async () => {
        if (!isCopying) {
            navigator.clipboard.writeText(code)
            setButtonText("Skopiowano do schowka")
            setIsCopying(true)
            await sleep(3000)
            setIsCopying(false)
            if (isMobywatelCodeActive) {
                setButtonText("Skopiuj kod")
            }
        }
    }

    const getValidButtonText = (): string =>
        isCopying || timeToCodeExpiresInSeconds == null
            ? buttonText
            : `${buttonText} (${Duration.fromObject({seconds: timeToCodeExpiresInSeconds}).toFormat('m:ss')})`;

    return (
        <section className={clsx(className)} style={style}>
            <header>
                <PageHeader level={HEADER_LEVEL.H2} title={"Kod:"}/>
            </header>
            {
                isMobywatelCodeActive ?
                    <>
                        <AppFrame className={clsx("app-code")}>
                            <Paragraph color={APP_COLOR.GRAY} size={APP_FONT_SIZE.EXTRA_SMALL}
                                       className={clsx("app-code")}>
                                {code}
                            </Paragraph>
                        </AppFrame>
                        <AppButton uiButtonType={UI_BUTTON_TYPE.PRIMARY}
                                   onClick={(e) => handleOnCopyClick()}>
                            {getValidButtonText()}
                        </AppButton>
                    </>
                    :

                    <>
                        <AppFrame className={clsx("app-code")}>
                            <Paragraph color={APP_COLOR.GRAY} size={APP_FONT_SIZE.EXTRA_SMALL}
                                       className={clsx("app-code")}>
                                <AppIcon icon={InfoIcon} decorative={true} className={"app-code-info-icon"}></AppIcon> Kod wygasł
                            </Paragraph>
                        </AppFrame>
                        <AppButton uiButtonType={UI_BUTTON_TYPE.PRIMARY}
                                   onClick={(e) => handleOnClick(e)}>
                            Odśwież
                        </AppButton>
                    </>
            }
        </section>

    )
}

export default AppCode